import { ObstetricalVisit } from "../../ObstetricalVisit";

class BritishColumbiaObstetricalVisit extends ObstetricalVisit {
    public Fundus?: number;
    public Urine: string;

    constructor(fields?: Partial<BritishColumbiaObstetricalVisit>) {
        super(fields);
        this.Fundus = fields?.Fundus;
        this.Urine = fields?.Urine;
    }
}

export { BritishColumbiaObstetricalVisit };
